import {
  BulkRewardResponse,
  ListScheduledRewards,
  MutationDeleteBulkRewardArgs,
  MutationModifyBulkRewardArgs,
  QueryListScheduledRewardsArgs
} from "@irati/types"
import {createUseMutation, createUseQuery} from "@irati/utils/services/apollo"
import gql from "graphql-tag"

export const useScheduledRewardsQuery = createUseQuery<ListScheduledRewards[], QueryListScheduledRewardsArgs>(
  gql`
    query ListScheduledRewards($input: ListScheduledRewardsInput!) {
      listScheduledRewards(input: $input) {
        uuid
        amount
        currency
        recipientCount
        message
        scheduledFor {
          when
          originalTimezone
        }
        destinationIds
      }
    }
  `,
  {
    key: "listScheduledRewards"
  }
)

export const useModifyBulkReward = createUseMutation<BulkRewardResponse, MutationModifyBulkRewardArgs>(gql`
  mutation ModifyBulkReward($input: ModifyBulkRewardInput!) {
    modifyBulkReward(input: $input) {
      uuid
      status
    }
  }
`)

export const useDeleteBulkReward = createUseMutation<boolean, MutationDeleteBulkRewardArgs>(gql`
  mutation DeleteBulkReward($id: ID!) {
    deleteBulkReward(id: $id)
  }
`)
